import { render, staticRenderFns } from "./bulk_import.vue?vue&type=template&id=35156bde"
import script from "./bulk_import.vue?vue&type=script&lang=js"
export * from "./bulk_import.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports